var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-input',{on:{"blur":_vm.setVal},model:{value:(_vm.DisplayLabel),callback:function ($$v) {_vm.DisplayLabel=$$v},expression:"DisplayLabel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }